import { useEffect, useRef } from 'preact/hooks';
import { CAT_DISPLAY } from './cats';
import { HudStore } from './store';

export function CatCard({ store }: { store: HudStore }) {
  const id = store.cardOpen.value;
  const ref = useRef<HTMLButtonElement>(null);
  useEffect(() => { if (id) ref.current?.focus(); }, [id]);
  if (!id) return null;
  const d = CAT_DISPLAY[id];
  const snap = store.snapshot.value;
  const c = snap?.cats.find((k) => k.id === id);
  const following = store.followed.value === id;
  const close = () => { store.cardOpen.value = null; };
  return (
    <section class="panel cat-card" role="dialog" aria-labelledby="cat-card-name" style={{ '--cat': d.colour }}>
      <div class="portrait" aria-hidden="true">{d.short[0]}</div>
      <h2 id="cat-card-name">{d.name}</h2>
      <dl>
        <dt>Lane</dt><dd>{d.lane + 1}</dd>
        <dt>Colour</dt><dd><span class="swatch" aria-hidden="true" /> {d.colourName}</dd>
        {c && snap && <><dt>Now</dt><dd>Place {c.place} · {HudStore.status(c, snap).text}</dd></>}
      </dl>
      <div class="actions">
        <button type="button" ref={ref} class={following ? 'on' : ''} aria-pressed={following} onClick={() => store.follow(id)}>{following ? 'Following' : 'Follow'}</button>
        <button type="button" onClick={close}>Close</button>
      </div>
    </section>
  );
}
